import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import { bemClassName } from 'utils/BEMHelper';

import styles from './ShareableReportRequirementCard.scss';
import ShareableReportRequirementItem from '../ShareableReportRequirementItem/ShareableReportRequirementItem';

const ShareableReportRequirementCard = ({
  icon,
  items,
  noBorder,
  isUnderwritten,
  defaultMessage,
}) => (
  <div styleName={bemClassName('m-shareable-requirement-card', { 'no-border': noBorder })}>
    {isUnderwritten ? null : !items.length ? (
      <ShareableReportRequirementItem italic title={defaultMessage} />
    ) : (
      items.map((title, index) => (
        <ShareableReportRequirementItem key={index} icon={icon} title={title} />
      ))
    )}
  </div>
);

ShareableReportRequirementCard.propTypes = {
  icon: PropTypes.string,
  noBorder: PropTypes.bool,
  items: PropTypes.array,
  isUnderwritten: PropTypes.bool,
  defaultMessage: PropTypes.string,
};

export default CSSModules(ShareableReportRequirementCard, styles, { allowMultiple: true });
